<template>
  <div>
    <div slot="title">
      <h2>Asignar Preguntas</h2>
      <span class="col-form-label">{{nombreCuestionario}}</span>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:50px;">
          <div class="col-5">
            <input type="text" class="form-control" placeholder="Buscar" v-model="textoBusqueda" />
          </div>
          <div class="col-5">
            <select class="form-control" id="categoriaPregunta" v-model="competenciaIdAux">
              <option selected>Competencia (Sin filtro)</option>

            </select>
          </div>
          <div class="col-2">
            <input type="button" class="form-control" value="Buscar" @click="buscarPreguntas" />
          </div>
        </div>
        <div class="row" style="margin-top:40px;">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaPreguntas">
                  <thead class="thead-dark">
                    <tr>
                      <th>Id Pregunta</th>
                      <th>Pregunta</th>
                      <th>Categoria</th>
                      <th>Competencia</th>
                      <th>Acciones</th>

                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr v-for='pregunta in preguntas' v-bind:id='pregunta.PreguntaId'>
                      <td>{{pregunta.PreguntaId}}</td>
                      <td>
                        {{pregunta.DescripcionPregunta}}
                      <td>{{pregunta.CategoriaCompetencia}}</td>
                      <td>{{pregunta.CompetenciaPregunta}}</td>
                      <td class='d-flex justify-content-around'>
                        <i class='fa fa-plus-circle' @click='agregarPregunta(pregunta)' />
                        <i class='fa fa-question-circle' @click='mostrarRespuestas(pregunta.PreguntaId,pregunta.Respuesta1,pregunta.Respuesta2,pregunta.Respuesta3,pregunta.Respuesta4)' />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <div class="row">
              <div class="col-4">
                <h5><span class="col-form-label">Cuestionario</span></h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaCuestionario">
                  <thead class="thead-dark">
                    <tr>
                      <th>No.</th>
                      <th>Pregunta</th>
                      <th>Categoria</th>
                      <th>Competencia</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for='(pregunta, index) in preguntas2' v-bind:id='pregunta.PreguntaId'>
                      <td>{{index}}</td>
                      <td>{{pregunta.DescripcionPregunta}}</td>
                      <td>{{pregunta.CategoriaCompetencia}}</td>
                      <td>{{pregunta.CompetenciaPregunta}}</td>
                      <td class='d-flex justify-content-around'>
                        <i class='fa fa-trash' @click='borrarPregunta($event,pregunta.PreguntaId)' />
                        <i class='fa fa-question-circle' @click='mostrarRespuestas(pregunta.PreguntaId,pregunta.Respuesta1,pregunta.Respuesta2,pregunta.Respuesta3,pregunta.Respuesta4)' />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-10"></div>
          <div class="col-2">
            <router-link to="/SISEVA/CatalogoCuestionarios">
              <input type="button" class="form-control" value="Guardar" v-bind:disabled="cuestionario.length<1" @click="asignarPreguntas" />
            </router-link>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  export default {
    props: ['idFormatoCuestionario'],
    data() {
      return {
        toastClass: 'hidding',
        numeroFilas: 1,
        nombreCuestionario: "",
        tipoCuestionarioId: 0,
        textoBusqueda: "",
        competenciaId: 0,
        competenciaIdAux: 0,
        numeroPreguntas: 0,
        cuestionario: [],
        preguntas: [],
        preguntas2: []
      }
    },
    components: {

    },
    methods: {
      showHideToast: function (flag) {
        console.log('entrar')
        if (flag) {
          this.toastClass = 'showing'
        }
        else {
          this.toastClass = 'hidding'
        }
      },
      agregarFila: function (event) {
        var row = event.target.parentElement.parentElement;

        $(row).prepend("<td>" + this.numeroFilas + "</td>")
        var instancia2 = new Vue({
          template: "<i class='fa fa-trash' @click='borrarFila'/>",
          methods: {
            borrarFila: this.borrarFila
          }
        })
        $(row.cells[row.cells.length-1].childNodes[0]).remove()
        instancia2.$mount()
        row.cells[row.cells.length-1].prepend(instancia2.$el)
        //alert(event.target.parentElement.parentElement.childNodes[0].innerHTML);
        $('#tablaCuestionario').find('tbody:last').append($(row));
        this.numeroFilas++;
      },
      reenumerar: function () {
        $("#fila-respuestas").remove();
        var table = $("#tablaCuestionario")
        table.find('tr').each(function (rowIndex, r) {
          if (rowIndex > 0) {
            r.cells[0].innerHTML = rowIndex+")"
          }
        });
        this.buscarPreguntas()
      },
      buscarCompetenciasPreguntas: function () {
        this.competenciaId = (this.competenciaIdAux == "0") ? null : parseInt(this.competenciaIdAux)
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false
        }
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.GetCompetenciasPreguntas, peticion).then(response => {
          if (response.data.SiHayError == false) {
            var categorias = response.data.CategoriasCompetencias
            var select = $('#categoriaPregunta')
            $.each(categorias, function () {
              var group = $('<optgroup label="' + this.Nombre + '" />');
              $(this.Competencias).each(function () {
                $(new Option(this.Nombre, this.CompetenciaPreguntaId)).html(this.Nombre).appendTo(group);
              });
              group.appendTo(select);
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },getInfoCuestionario: function () {
        var peticion = {
          "esPrueba": false,
          "idFormatoCuestionario": this.idFormatoCuestionario
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetFormatoCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.nombreCuestionario = response.data.FormatoCuestionario.nombreCuestionario
            this.tipoCuestionarioId = response.data.FormatoCuestionario.idTipoCuestionario
            this.cargarPreguntas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarPreguntas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición

        this.competenciaId = (this.competenciaIdAux == 0) ? null : this.competenciaIdAux
        var peticion = {
          "esPrueba": false,
          "textoBusqueda": this.textoBusqueda,
          "competenciaId": this.competenciaId,
          "tipoCuestionario": this.tipoCuestionarioId,
          "baneados": this.cuestionario
        };
        console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.GetPreguntas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            
            this.preguntas = response.data.Preguntas//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaPreguntas', 10)
            })

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      agregarPregunta: function (infoPregunta) {
        this.anadirPregunta(infoPregunta)
        this.buscarPreguntas()
      },
      anadirPregunta: function (infoPregunta) {
        this.numeroPreguntas++
        this.preguntas2 .push(infoPregunta),//Carga los datos necesarios
          this.cuestionario.push(infoPregunta.PreguntaId)
        this.$nextTick(() => {
              PaginarTabla('tablaCuestionario', 10)
            })
      },
      asignarPreguntas: function () {
        var peticion = {
          "esPrueba": false,
          "formatoCuestionarioId": this.idFormatoCuestionario,
          "preguntasId": this.cuestionario
        }
        axios.post(api.conexion + api.SISEVA.funcion.AsignarPreguntas, peticion).then(response => {
          if (response.data.SiHayError == false) {
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cargarPreguntas: function () {
        var peticion = {
          "esPrueba": false,
          "formatoCuestionarioId": this.idFormatoCuestionario
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetPreguntasFormatoCuestionario, peticion).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response)
            var funcion = this.anadirPregunta
            response.data.preguntas.forEach(function (pregunta) {
              funcion(pregunta)
            });
            this.buscarPreguntas();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      borrarPregunta: function (event, idPregunta) {
        this.cuestionario.splice($.inArray(idPregunta, this.cuestionario), 1);
        var boton = event.target;
        var row = boton.parentElement.parentElement;
        if (row.tagName == "TR") {
          row.remove();
        }
        this.reenumerar()
      },
      mostrarRespuestas: function (PreguntaId, Respuesta1, Respuesta2, Respuesta3, Respuesta4) {
        $("#fila-respuestas").remove();
        $('#' + PreguntaId).after('<tr id="fila-respuestas"><td><div>Respuestas:</div></td><td colspan="4">' +
          '<div><ol><li>' + Respuesta1 + '</li>' +
          '<li>' + Respuesta2 + '</li>' +
          '<li>' + Respuesta3 + '</li>' +
          '<li>' + Respuesta4 + '</li></ol></div>' +
          '</td></tr>');
        var cosa = $('#' + PreguntaId).next()
        console.log(cosa)
        cosa.focus()
        cosa.toggleClass('transition')
      }
    }, mounted: function () {
      this.buscarCompetenciasPreguntas();
      this.getInfoCuestionario();
      
    }

  }

</script>

<style scoped>
  .showing {
    visibility: visible;
    border: solid;
    padding: 5px;
  }

  .hidding {
    visibility: hidden;
    border: solid;
    padding: 5px;
  }

  i {
    cursor: pointer;
  }

  #fila-respuestas div {
    max-height: 0px;
    overflow: hidden;
    transition: max-height 1.5s ease;
  }

  #fila-respuestas.transition div {
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/AsignarPreguntas.vue